import { SET_PINNED_ANNOUNCEMENTS, SET_PINNED_POSTS } from '../actions/actionTypes';

const preState = {
	announcements: [],
	posts: [],
};

const pinnedReducer = (state = preState, action) => {
	Object.freeze(state);
	const stateDup = { ...state };
	const { type, announcements, posts } = action;
	switch (type) {
		case SET_PINNED_ANNOUNCEMENTS:
			return { ...stateDup, announcements };
		case SET_PINNED_POSTS:
			return { ...stateDup, posts };
		default:
			return stateDup;
	}
};

export default pinnedReducer;
